import React, { useState, useEffect } from "react";
//import { DateRangePicker as KenDateRangePicker } from "@progress/kendo-react-dateinputs";
import "../../styles/nimbly2.css";
import {
    Chart,
    ChartArea,
    ChartTitle,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisTitle,
    ChartCategoryAxisItem,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import CSMapPage from "../construction_services/cs_mapcontainer";
import FSMapPage from "../field_services/fs_mapcontainer";
import RSMapPage from "../reliability_services/rs_mapcontainer";
import RSMapPageUG from "../reliability_services_UG/rs_mapcontainer";
import {
    ExpansionPanel,
    ExpansionPanelContent,
} from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import loadinggif from "../../assets/loading.gif";
import { useProject } from '../../contexts/ProjectContext';
import { useEnvironmentConfigContext } from '../../contexts/EnvironmentConfigContext';

const titkeElement = () => (
    <div>
        <p className="pulse-chart-title">Pole Count by Status:</p>
        <p className="pulse-chart-title">Pole Count by Status:</p>

    </div>
);

const MapPage = ({ onPageChange }) => {
    const { selectedProject, GCP_Project, Dataset_ID, segment, hasMeterTable } = useProject();
    const { environmentConfig } = useEnvironmentConfigContext();

    let MapComponent;

    if (hasMeterTable) {
        MapComponent = <FSMapPage />;
    } else if (segment === "Doublewood") {
        MapComponent = <CSMapPage />;
    } else if (segment === "Underground") {
        MapComponent = <RSMapPageUG />;
    } else {
        MapComponent = <RSMapPage />;
    }

    return (
        <div className="ken-nimbly-map-page-content-wrapper">
            {MapComponent}
        </div>
    )
}
export default MapPage;
